export default (props) => ({
  __typename: 'FaqBlock',
  ...props.title && {
    title: props.title,
  },
  ...props.faq_entries && {
    questions: props.faq_entries,
  },
})
